import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MindeeReceipt } from './mindee';

@Injectable({
  providedIn: 'root',
})
export class MindeeService {
  private apiUrl = 'https://api.mindee.net/v1/products/mindee/expense_receipts/v5/predict';
  private token = 'd3ca70f281ff00202d25be838e9f3557';
  private httpClient: HttpClient;

  constructor(private handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  makeRequest(file: File): Observable<MindeeReceipt> {
    const headers = new HttpHeaders().set('Authorization', `Token ${this.token}`);
    const formData = new FormData();
    formData.append('document', file, file.name);
    return this.httpClient.post<MindeeReceipt>(this.apiUrl, formData, {
      headers,
    });
  }
}
